export const GET_ALL_DASHBOARD_DATA = 'GET_ALL_DASHBOARD_DATA';
